<template>
	
	<div class="breadcrumbs">
		<ul>
			<li :key="breadcrumb.id" v-for="(breadcrumb, i) in breadcrumbs">
                <a :href="breadcrumb.linkURL" v-if="i != breadcrumbs.length - 1">{{ breadcrumb.linkText }}</a>
                <div v-if="i == breadcrumbs.length - 1">{{ breadcrumb.linkText }}</div>
            </li>
		</ul>
	</div>
	
</template>

<script>
	
	export default {
		name: 'Breadcrumbs',
		
		props: ['breadcrumbs']
	}
	
</script>